import { __extends } from "tslib";
import { DiffuseBasicMethod } from './DiffuseBasicMethod';
import { CompositeMethodBase } from './CompositeMethodBase';
/**
 * DiffuseCompositeMethod provides a base class for diffuse methods that wrap a diffuse method to alter the
 * calculated diffuse reflection strength.
 */
var DiffuseCompositeMethod = /** @class */ (function (_super) {
    __extends(DiffuseCompositeMethod, _super);
    /**
     * Creates a new <code>DiffuseCompositeMethod</code> object.
     *
     * @param modulateMethod The method which will add the code to alter the base method's strength. It needs to have the signature clampDiffuse(t:ShaderRegisterElement, regCache:ShaderRegisterCache):string, in which t.w will contain the diffuse strength.
     * @param baseMethod The base diffuse method on which this method's shading is based.
     */
    function DiffuseCompositeMethod(baseMethod) {
        if (baseMethod === void 0) { baseMethod = null; }
        return _super.call(this, baseMethod) || this;
    }
    DiffuseCompositeMethod.prototype.createBaseMethod = function () {
        return new DiffuseBasicMethod();
    };
    Object.defineProperty(DiffuseCompositeMethod.prototype, "texture", {
        /**
         * @inheritDoc
         */
        get: function () {
            return this._baseMethod.texture;
        },
        set: function (value) {
            this._baseMethod.texture = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiffuseCompositeMethod.prototype, "color", {
        /**
         * @inheritDoc
         */
        get: function () {
            return this._baseMethod.color;
        },
        set: function (value) {
            this._baseMethod.color = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DiffuseCompositeMethod.prototype, "multiply", {
        /**
         * @inheritDoc
         */
        get: function () {
            return this._baseMethod.multiply;
        },
        set: function (value) {
            this._baseMethod.multiply = value;
        },
        enumerable: false,
        configurable: true
    });
    return DiffuseCompositeMethod;
}(CompositeMethodBase));
export { DiffuseCompositeMethod };
